import DragDropContainer from './DragDropContainer.vue'
export default DragDropContainer
